import { render } from "./MainSection.vue?vue&type=template&id=6012703e&ts=true"
import script from "./MainSection.vue?vue&type=script&lang=ts"
export * from "./MainSection.vue?vue&type=script&lang=ts"

import "./MainSection.vue?vue&type=style&index=0&id=6012703e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__